<!--
    描述：日常考核
    时间：2021-07-06
    Created by 王帅
-->
<template>
    <div class="filter-layout">
        <div class="filter-box pdt10">
            <el-form
                ref="searchForm"
                v-show="filterShow"
                :model="searchObj"
                label-width="110px"
            >
                <el-row>
                    <el-col :span="5">
                        <el-form-item label="考核类型：" prop="markObj">
                            <el-select
                                v-model="searchObj.markObj"
                                placeholder="请选择考核类型"
                                size="small"
                                clearable
                            >
                                <el-option
                                    v-for="(item, index) in khlx"
                                    :key="'对象' + index"
                                    :label="item.sname"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="考核内容：" prop="objName">
                            <el-input
                                v-model="searchObj.objName"
                                size="small"
                                placeholder="请输入"
                                clearable
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="申报人：" prop="beJudger">
                            <el-input
                                v-model="searchObj.beJudger"
                                size="small"
                                placeholder="请输入"
                                clearable
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="申报单位：" prop="beUnitName">
                            <el-input
                                v-model="searchObj.beUnitName"
                                size="small"
                                placeholder="请输入"
                                clearable
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="10">
                        <el-form-item label="申报时间：" prop="startTime">
                            <el-col :span="11">
                                <el-date-picker
                                    class="w100"
                                    v-model="searchObj.startTime"
                                    type="date"
                                    placeholder="请选择时间"
                                    size="small"
                                    value-format="yyyy-MM-dd"
                                    :clearable="false"
                                    :picker-options="startDatePicker"
                                ></el-date-picker>
                            </el-col>
                            <el-col :span="2" class="text-center">~</el-col>
                            <el-col :span="11">
                                <el-date-picker
                                    class="w100"
                                    v-model="searchObj.endTime"
                                    type="date"
                                    placeholder="请选择时间"
                                    size="small"
                                    value-format="yyyy-MM-dd"
                                    :clearable="false"
                                    :picker-options="endDatePicker"
                                ></el-date-picker>
                            </el-col>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="考核单位：" prop="unitName">
                            <el-input
                                v-model="searchObj.unitName"
                                size="small"
                                placeholder="请输入"
                                clearable
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="状态：" prop="status">
                            <el-select
                                v-model="searchObj.status"
                                placeholder="请选择状态"
                                size="small"
                                clearable
                            >
                                <el-option value="0" label="待申报"></el-option>
                                <el-option value="1" label="已申报"></el-option>
                                <el-option value="2" label="已审核"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4" class="mt5 text-right">
                        <el-button
                            type="primary"
                            class="btn-blue"
                            size="small"
							icon="el-icon-search"
                            @click="doSearch('1')"
                            >查询</el-button
                        >
                        <el-button size="small" @click="doRefresh" icon="el-icon-refresh"
                            >重置</el-button
                        >
                    </el-col>
                </el-row>
            </el-form>

            <!-- 筛选折叠按钮 -->
            <div class="control-btn" @click="filterShow = !filterShow">
                <span v-if="filterShow">
                    点击收起
                    <svg-icon icon-class="pack-up" class="c-icon ml5"></svg-icon>
                </span>
                <span v-else
                    >筛选
                    <svg-icon icon-class="pack-down" class="c-icon ml5"></svg-icon>
                </span>
            </div>
        </div>
        <div class="filter-content primary-layout">
            <!-- 头部按钮 -->
            <div class="primary-header">
                <div class="title">
                    合计考核项：<span class="blue">{{ searchObj.totalResult }}</span> 条
                </div>
                <div class="btnGroups">
                    <el-button size="small" type="success" @click="handleTools('add')"
                               v-if="roleBtns.includes('add_declare')">新增申报</el-button>
                    <el-button
                        size="small"
                        class="btn-blue"
                        icon="el-icon-refresh"
                        type="primary"
                        @click="doRefresh"
                    ></el-button>
                </div>
            </div>

            <!-- 表格内容 -->
            <div class="primary-content w-table-layout w-table-page">
                <div class="w-table-content">
                    <vxe-table
                        :data="tableObj.tableData"
                        :loading="tableObj.loading"
                        :border="tableObj.border"
                        :resizable="tableObj.resizable"
                        :size="tableObj.size"
                        :height="tableObj.height"
                        highlight-current-row
                        highlight-hover-row
                        auto-resize
                        show-overflow="tooltip"
                        show-header-overflow="tooltip"
                    >
                        <vxe-table-column
                            type="seq"
                            title="序号"
                            width="60"
                            align="center"
                        ></vxe-table-column>
                        <vxe-table-column
                            v-for="(item, index) in activeColumns"
                            :key="item.prop"
                            :field="item.prop"
                            :title="item.title"
                            :min-width="item.minWidth"
                            :width="item.width"
                            :align="item.align"
                            :header-align="item.headerAlign"
                        >
                            <template v-slot="{ row }" v-if="item.needRender">
                                <span :class="dealClass(row, item.prop)">{{ item.function(row[item.prop]) }}</span>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column title="操作" min-width="260" align="center">
                            <template v-slot="{ row }">
                                <el-button
                                        type="primary"
                                        size="small"
                                        round
                                        plain
                                        class="table-btn"
                                        v-if="roleBtns.includes('view_btn') && parseInt(row.status) !== 0"
                                        @click="handleTools('view', row)">
                                    <svg-icon icon-class="form-look"></svg-icon> 查看
                                </el-button>
                                <el-button
                                    type="success"
                                    size="small"
                                    round
                                    plain
                                    class="table-btn"
                                    v-if="roleBtns.includes('edit_btn') && parseInt(row.status) === 0"
                                    @click="handleTools('edit', row)">
                                    <svg-icon icon-class="form-edit"></svg-icon> 编辑
                                </el-button>
                                <el-button
                                    type="success"
                                    size="small"
                                    round
                                    plain
                                    class="table-btn"
                                    v-if="roleBtns.includes('assess_btn') && parseInt(row.status) !== 0"
                                    :disabled="parseInt(row.status) !== 1"
                                    @click="handleTools('check', row)">
                                    <svg-icon icon-class="form-shenhe"></svg-icon> 考核
                                </el-button>
                                <el-button
                                    type="danger"
                                    size="small"
                                    round
                                    plain
                                    class="table-btn"
                                    icon="el-icon-delete"
                                    v-if="roleBtns.includes('del_btn')"
                                    :disabled="parseInt(row.status) !== 0"
                                    @click="handleTools('delete', row)">删除
                                </el-button>
                            </template>
                        </vxe-table-column>
                    </vxe-table>
                </div>
                <div class="w-table-footer" style="font-size: 13px">
                    <vxe-pager
                        :current-page="searchObj.current"
                        :page-size="searchObj.size"
                        :total="searchObj.totalResult"
                        class="text-center"
                        :page-sizes="[10, 20, 50, 100, { label: '全部数据', value: -1 }]"
                        :layouts="[
                            'Total',
                            'Sizes',
                            'PrevPage',
                            'JumpNumber',
                            'NextPage',
                            'FullJump',
                        ]"
                        @page-change="handlePageChange"
                    >
                    </vxe-pager>
                </div>
            </div>
        </div>

        <!-- 新增弹窗 -->
        <el-dialog
            :visible.sync="dialogObj.visible"
            :width="dialogObj.width"
            :title="dialogObj.title"
            center
            :close-on-click-modal="false"
            @closed="handleClose"
        >
            <!-- 初始选择 -->
            <template v-if="dialogObj.visible && dialogObj.showMode === 'select'">
                <div class="select-header text-overflow">
                    选择考核类型：
                    <span
                        v-for="(item, index) in khlx"
                        :key="'考核类型选择' + index"
                        :class="{ active: item.value === selectedType }"
                        @click="changeApplyType(item)"
                        ><i
                            class="el-icon-check mr5"
                            v-if="item.value === selectedType"
                        ></i
                        >{{ item.sname }}</span
                    >
                </div>
                <div class="w-table-layout w-table-page">
                    <div class="w-table-content">
                        <vxe-table
                            :data="selectObj.tableData"
                            :loading="selectObj.loading"
                            :border="selectObj.border"
                            :resizable="selectObj.resizable"
                            :size="selectObj.tableSize"
                            :height="selectObj.height"
                            highlight-current-row
                            highlight-hover-row
                            auto-resize
                            show-overflow="tooltip"
                            show-header-overflow="tooltip"
                        >
                            <vxe-table-column
                                type="seq"
                                title="序号"
                                width="60"
                                align="center"
                            ></vxe-table-column>
                            <vxe-table-column
                                v-for="(item, index) in selectColumns"
                                :key="item.prop"
                                :field="item.prop"
                                :title="item.title"
                                :min-width="item.minWidth"
                                :width="item.width"
                                :align="item.align"
                                :header-align="item.headerAlign"
                            >
                                <template v-slot="{ row }" v-if="item.needRender">
                                    <span>{{ item.function(row[item.prop]) }}</span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column title="操作" min-width="160" align="center">
                                <template v-slot="{ row }">
                                    <el-button
                                        type="primary"
                                        size="small"
                                        round
                                        plain
                                        class="table-btn"
                                        @click="handleTools('select', row)"
                                    >
                                        <i class="el-icon-check"></i> 选择
                                    </el-button>
                                </template>
                            </vxe-table-column>
                        </vxe-table>
                    </div>
                    <div class="w-table-footer" style="font-size: 13px">
                        <vxe-pager
                            :current-page="selectObj.current"
                            :page-size="selectObj.size"
                            :total="selectObj.totalResult"
                            class="text-center"
                            :page-sizes="[
                                10,
                                20,
                                50,
                                100,
                                { label: '全部数据', value: -1 },
                            ]"
                            :layouts="[
                                'Total',
                                'Sizes',
                                'PrevPage',
                                'JumpNumber',
                                'NextPage',
                                'FullJump',
                            ]"
                            @page-change="handleSelectChange"
                        >
                        </vxe-pager>
                    </div>
                </div>
            </template>

            <!-- 选择考核 -->
            <template v-if="dialogObj.visible && dialogObj.showMode === 'score'">
                <public-evaluate
                    ref="evaluate"
                    :objName="evaluateObj.objName"
                    :proTypeName="evaluateObj.proTypeName"
                    :markObj="selectedType"
                    :markObjName="evaluateObj.markObjName"
                    :bejudger="evaluateObj.bejudger"
                    :beUnitName="evaluateObj.beUnitName"
                    :status="evaluateObj.status"
                    :mode="dialogObj.type"
                ></public-evaluate>

                <div slot="footer" class="text-center pdb10" v-if="dialogObj.type !== 'view'">
                    <el-button @click="handleClose">取消</el-button>
                    <el-button type="success" :loading="btnLoading" v-if="dialogObj.type !== 'check'" @click="onSubmit('0')">暂保存</el-button>
                    <el-button type="primary" :loading="btnLoading" @click="onSubmit('1')"
                        >提交</el-button
                    >
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import * as Api from "api/evaluateManage/DailyEvaluate.js";
import { mapState } from "vuex";
import PublicEvaluate from "./PublicEvaluate.vue";
import { $deepCopy } from 'utils/tools.js'

export default {
    components: { PublicEvaluate },
    name: "DailyEvaluate",
    data() {
        return {
            filterShow: true,
            searchObj: {
                markObj: "",
                objName: "", // 考核内容
                beJudger: "", // 申报人
                beUnitName: "", // 申报单位
                unitName: "", // 考核单位
                startTime: "",
                endTime: "",
                status: "", // 0：待申报 1：已申报 2：已审核
                current: 1,
                size: 10,
                totalResult: 0,
            },
            // 表格对象
            tableObj: {
                tableData: [],
                loading: false,
                border: true,
                resizable: true,
                size: "small",
                height: "100%",
            },
            startDatePicker: this.beginDate(),
            endDatePicker: this.processDate(),
            // 新增相关
            // 弹窗对象
            dialogObj: {
                visible: false,
                width: "80%",
                title: "新增",
                type: "add",
                btnLoading: false,
                showMode: "",
            },
            selectedType: null,
            selectObj: {
                tableData: [],
                loading: false,
                border: true,
                resizable: true,
                tableSize: "small",
                height: "500px",
                current: 1,
                size: 10,
                totalResult: 0,
            },
            // 考核弹窗界面参数
            evaluateObj: {
                opeRecordDetails: [],
                busProjectId: null, // 项目表ID
                objName: "", // 工程项目名称
                proTypeName: "", // 项目类型
                markObj: "", // 考核类型
                markObjName: "", // 考核类型名称
                bejudger: "", // 申报人
                beUnitName: "", // 申报单位
                unitName: "", // 考核单位
                declareTotal: 0,
                currentId: "", // 修改时主键ID
                status: 0
            },
            btnLoading: false,
        };
    },
    created() {
        this.doSearch(1);
        console.log(this.roleBtns)
        // console.log('发版成功')
    },
    methods: {
        // 开始时间的 pickOption
        beginDate() {
            let that = this;
            return {
                disabledDate(time) {
                    let endTime = "";
                    // endTime = new Date(that.searchObj.endTime).getTime() + 86400000;
                    endTime = new Date(that.searchObj.endTime).getTime();
                    if (endTime) {
                        return time.getTime() > endTime;
                    } else {
                        return time.getTime() > Date.now();
                    }
                },
            };
        },

        // 结束时间的 pickOption
        processDate() {
            let that = this;
            return {
                disabledDate(time) {
                    let startTime = "";
                    startTime = new Date(that.searchObj.startTime).getTime() - 86400000;
                    if (startTime) {
                        return time.getTime() < startTime || time.getTime() < Date.now();
                    } else {
                        return time.getTime() < Date.now() - 86400000;
                    }
                },
            };
        },

        // 查询数据
        doSearch(page) {
            if (page) {
                this.searchObj.size = 10;
                this.searchObj.current = 1;
            }
            let params = this.$utils.clone(this.searchObj, true);
            params.startTime =
                params.startTime === ""
                    ? params.startTime
                    : params.startTime + " 00:00:00";
            params.endTime =
                params.endTime === "" ? params.endTime : params.endTime + " 23:59:59";
            this.tableObj.loading = true;
            Api.getListData(params)
                .then((res) => {
                    // console.log(res)
                    this.tableObj.loading = false;
                    if (res.operationCode === 1) {
                        this.tableObj.tableData = res.data.records;
                        if (this.searchObj.size != -1) {
                            this.searchObj.totalResult = parseInt(res.data.total);
                        }
                    }
                })
                .catch((err) => {
                    this.tableObj.loading = false;
                });
        },

        // 外面切换分页
        handlePageChange({ currentPage, pageSize }) {
            this.searchObj.current = currentPage;
            this.searchObj.size = pageSize;
            this.doSearch();
        },

        // 外面表格刷新
        doRefresh() {
            this.$refs.searchForm.resetFields();
            this.searchObj.endTime = ''
            this.searchObj.size = 10;
            this.searchObj.current = 1;
            this.searchObj.totalResult = 0;

            this.doSearch();
        },

        // 新增申报选择
        getSelectData(page) {
            if (page) {
                this.selectObj.size = 10;
                this.selectObj.current = 1;
            }
            let params = {
                current: this.selectObj.current,
                size: this.selectObj.size,
                judgeRole: "1013002", //考核人主体类型
                beJudgeRole: "1013003", //被考核人主体类型
                markObj: this.selectedType, // 考核类型
            };
            this.selectObj.tableData = [];

            Api.getSelectData(params)
                .then((res) => {
                    this.selectObj.tableData = res.data.records;
                    this.selectObj.totalResult = parseInt(res.data.total);
                })
                .catch((err) => {
                    this.selectObj.tableData = [];
                });
        },

        // 切换申报类型
        changeApplyType(item) {
            this.selectedType = item.value;

            this.getSelectData(1);
        },

        // 里面切换分页
        handleSelectChange({ currentPage, pageSize }) {
            this.selectObj.current = currentPage;
            this.selectObj.size = pageSize;
            this.getSelectData();
        },

        // 操作函数
        handleTools(type, row) {
            switch (type) {
                // 新增申报
                case "add":
                    this.dialogObj.visible = true;
                    this.dialogObj.type = "add";
                    this.dialogObj.title = "新增";
                    this.dialogObj.showMode = "select";

                    if (this.khlx.length > 0) {
                        this.selectedType = this.khlx[0].value;

                        this.getSelectData();
                    }

                    break;
                // 点击选择
                case "select":
                    // 获取详细规则
                    this.getRulesList();

                    // 保存参数
                    this.evaluateObj.busProjectId = row.busProjectId;
                    this.evaluateObj.objName = row.proName;
                    this.evaluateObj.proTypeName = row.proTypeName;
                    break;
                // 点击查看
                case "view":
                    this.dialogObj.visible = true;
                    this.dialogObj.type = "view";
                    this.dialogObj.showMode = "score";
                    this.dialogObj.title =
                        "东部新中心工程价款委托审计项目日常性考核内容及评分标准明细表";

                    // 回显数据
                    this.setData(row)
                    break;
                // 点击编辑
                case "edit":
                    this.dialogObj.visible = true;
                    this.dialogObj.type = "edit";
                    this.dialogObj.showMode = "score";
                    this.dialogObj.title =
                        "东部新中心工程价款委托审计项目日常性考核内容及评分标准明细表";

                    // 回显数据
                    this.setData(row)
                    break;
                // 点击审核
                case "check":
                    this.dialogObj.visible = true;
                    this.dialogObj.type = "check";
                    this.dialogObj.showMode = "score";
                    this.dialogObj.title =
                        "东部新中心工程价款委托审计项目日常性考核内容及评分标准明细表";

                    // 回显数据
                    this.setData(row)
                    break;
                // 点击删除
                case "delete":
                    this.tableObj.loading = true;
                    this.$confirm("确认删除吗?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                        .then(() => {
                            Api.deleteItem({ id: row.id })
                                .then((res) => {
                                    this.tableObj.loading = false;
                                    // 刷新页面
                                    this.doSearch(1);
                                })
                                .catch((err) => {
                                    this.tableObj.loading = false;
                                });
                        })
                        .catch(() => {
                            this.tableObj.loading = false;
                        });
                    break;
            }
        },

        // 回显数据操作
        setData(row) {
            this.evaluateObj.currentId = row.id;
            this.evaluateObj.versionId = row.versionId;
            this.evaluateObj.objName = row.objName;
            this.evaluateObj.markObj = row.markObj;
            this.evaluateObj.markObjName = row.markObjName;
            this.evaluateObj.bejudger = row.beJudger;
            this.evaluateObj.beUnitName = row.beUnitName;
            this.evaluateObj.status = parseInt(row.status);
            this.getApplyInfo(row);
        },

        // 新增时获取规则
        getRulesList() {
            let params = {
                judgeRole: "1013002", //考核人主体类型
                beJudgeRole: "1013003", //被考核人主体类型
                markObj: this.selectedType, //考核类型
                applyBus: "1016001", //适用业务(审计系统码表写死)
            };
            Api.getRulesData(params)
                .then((res) => {
                    if (!res.data) {
                        this.$message.error(res.msg)
                        return
                    }
                    // 成功展示弹窗
                    this.dialogObj.title =
                        "东部新中心跟踪审计委托审计项目日常性考核内容及评分标准明细表";
                    this.dialogObj.showMode = "score";

                    res.data.mapList.map(
                        (x) => ((x.declareScore = null), (x.ruleItemId = x.id))
                    );
                    setTimeout(() => {
                        this.$nextTick(() => {
                            this.$refs.evaluate.tableObj.tableData = res.data.mapList;
                            this.$refs.evaluate.totalScore = parseFloat(
                                res.data.totalScore
                            );
                        });
                    }, 100);
                })
                .catch((err) => {
                    this.evaluateObj.tableData = [];
                });
        },

        // 保存、提交
        onSubmit(status) {
            this.btnLoading = true;
            let params = {};
            if (this.dialogObj.type === "add") {
                params = {
                    createUserid: this.userInfo.id, //创建人id
                    status: status, //状态 申报状态 0：待申报 1：已申报 2：已审核
                    busProjectId: this.evaluateObj.busProjectId, // 业务id --selProjectApplyPageInfo接口返回的 busProjectId
                    objName: this.evaluateObj.objName, // 工程项目名称
                    markObj: this.selectedType, //考核类型
                    judgeRole: "1013002",
                    bejudgeRole: "1013003",
                    bejudger: this.userInfo.sname, // 申报人
                    beUnitName: this.$refs.evaluate.companyName, // 申报单位
                    unitName: this.$refs.evaluate.unitName, // 考核单位
                    tenantId: this.$refs.evaluate.selectUnit,
                    declareTotal: this.$refs.evaluate.sumTotal, // 申报总分
                    opeRecordDetails: this.$refs.evaluate.tableObj.tableData, //评分标准明细信息
                };
            } else if (this.dialogObj.type === 'edit') {
                params = {
                    id: this.evaluateObj.currentId,
                    updateUserid: this.userInfo.id, // 修改人ID
                    status: status, //状态 申报状态 0：待申报 1：已申报 2：已审核
                    unitName: this.$refs.evaluate.unitName, // 考核单位
                    tenantId: this.$refs.evaluate.selectUnit,
                    declareTotal: this.$refs.evaluate.sumTotal,
                    opeRecordDetails: this.$refs.evaluate.tableObj.tableData, //评分标准明细信息
                };
            } else {
                params = {
                    recordId: this.evaluateObj.currentId,//考核记录id
                    createUserid: this.userInfo.id,
                    status: "2",
                    versionId: this.evaluateObj.versionId,
                    assessTotal: this.$refs.evaluate.sumCheckTotal,//考核总分
                    opeRecordDetails: JSON.parse(JSON.stringify(this.$refs.evaluate.tableObj.tableData))
                }
            }

            // 非考核时验证 考核单位
            if (this.dialogObj.type !== 'check' && params.unitName === "") {
                this.$message.warning("请选择考核单位！");
                setTimeout(() => {
                    this.btnLoading = false;
                }, 2000);
                return;
            }

            // 数据判断
            let _pass = this.$refs.evaluate.saveJudge()
            if (!_pass) {
                setTimeout(() => {
                    this.btnLoading = false;
                }, 2000);
                return
            }

            if (this.dialogObj.type !== 'check') {
                // 接口
                Api.saveOrUpdate(params)
                    .then((res) => {
                        this.btnLoading = false;
    
                        this.handleClose();
                    })
                    .catch(() => {
                        setTimeout(() => {
                            this.btnLoading = false;
                        }, 2000);
                    });
            } else {
                params.opeRecordDetails.map(x => { x.id = x.opeRecordDetailId })
                // 接口
                Api.doEvaluate(params)
                    .then((res) => {
                        this.btnLoading = false;
    
                        this.handleClose();
                    })
                    .catch(() => {
                        setTimeout(() => {
                            this.btnLoading = false;
                        }, 2000);
                    });
            }
        },

        // 查看申报
        getApplyInfo(row) {
            let params = {
                id: row.id,
                judgeRole: "1013002",
                beJudgeRole: "1013003",
                markObj: row.markObj,
            };
            Api.getApplyInfo(params)
                .then((res) => {
                    setTimeout(() => {
                        this.$nextTick(() => {
                            this.$refs.evaluate.showUnitName = row.unitName
                            this.$refs.evaluate.selectUnit = row.judgeUnit
                            this.evaluateObj.proTypeName = res.data.proTypeName

                            res.data.opeRuleItems.map(
                                (x) => (x.ruleItemId = x.id)
                            );

                            this.$refs.evaluate.tableObj.tableData =
                                res.data.opeRuleItems;
                            this.$refs.evaluate.totalScore = parseFloat(
                                res.data.totalScore
                            );
                        });
                    }, 100);
                })
                .catch((err) => {});
        },

        // 左侧弹窗关闭
        handleClose() {
            this.dialogObj.visible = false;
            this.dialogObj.showMode = "";

            // 一些参数清空
            this.evaluateObj.opeRecordDetails = []
            this.evaluateObj.busProjectId = ''
            this.evaluateObj.objName = ''
            this.evaluateObj.proTypeName = ''
            this.evaluateObj.markObj = ''
            this.evaluateObj.markObjName = ''
            this.evaluateObj.beJudger = ''
            this.evaluateObj.beUnitName = ''
            this.evaluateObj.unitName = ''
            this.evaluateObj.declareScore = 0
            this.evaluateObj.status = 0
            this.evaluateObj.currentId = ''
            this.evaluateObj.versionId = ''

            this.doSearch();
        },

        // 重置查询条件
        resetFields() {
            this.$refs.searchForm.resetFields();
        },

        // dealClass
        dealClass(row, prop) {
            if (prop != 'status') {
                return
            }
            let status = row.status
            let msg = ''
            switch (parseInt(status)) {
                case 0:
                    msg = 'ToBeOperating'
                    break
                case 1:
                    msg = 'operated2'
                    break
                case 2:
                    msg = 'operated'
                    break
            }
            return msg
        }
    },
    computed: {
        ...mapState('menu', {
            roleBtns: (state) => state.roleBtns,
        }),
        // 动态列
        activeColumns() {
            let columns = [
                {
                    prop: "markObjName",
                    title: "考核类型",
                    minWidth: 0,
                    width: 150,
                    headerAlign: "center",
                    align: "left",
                },
                {
                    prop: "objName",
                    title: "考核内容",
                    minWidth: 160,
                    width: 0,
                    headerAlign: "center",
                    align: "left",
                },
                {
                    prop: "beJudger",
                    title: "申报人",
                    minWidth: 0,
                    width: 120,
                    headerAlign: "center",
                    align: "center",
                },
                {
                    prop: "beUnitName",
                    title: "申报单位",
                    minWidth: 180,
                    width: 0,
                    headerAlign: "center",
                    align: "left",
                },
                {
                    prop: "createDate",
                    title: "申报时间",
                    minWidth: 0,
                    width: 160,
                    headerAlign: "center",
                    align: "left",
                },
                {
                    prop: "declareTotal",
                    title: "申报分值",
                    minWidth: 0,
                    width: 80,
                    headerAlign: "center",
                    align: "center",
                    needRender: true,
                    function: (val) => {
                        if(val == 0){
                            return 0
                        }
                        return val ? val : "---";
                    },
                },
                {
                    prop: "unitName",
                    title: "考核单位",
                    minWidth: 180,
                    width: 0,
                    headerAlign: "center",
                    align: "left",
                },
                {
                    prop: "assessTotal",
                    title: "考核分值",
                    minWidth: 0,
                    width: 80,
                    headerAlign: "center",
                    align: "center",
                    needRender: true,
                    function: (val) => {
                        if(val == 0){
                            return 0
                        }
                        return val ? val : "---";
                    },
                },
                {
                    prop: "markResult",
                    title: "考核结果",
                    minWidth: 0,
                    width: 100,
                    headerAlign: "center",
                    align: "center",
                    needRender: true,
                    function: (val) => {
                        if ((!val && val != 0) || parseInt(val) === NaN) {
                            return "---";
                        }
                        let str = "";
                        switch (parseInt(val)) {
                            case 0:
                                str = "差评";
                                break;
                            case 1:
                                str = "良好";
                                break;
                            case 2:
                                str = "优秀";
                                break;
                            case 3:
                                str = "完美";
                                break;
                        }
                        return str;
                    },
                },
                {
                    prop: "status",
                    title: "状态",
                    minWidth: 0,
                    width: 100,
                    headerAlign: "center",
                    align: "center",
                    needRender: true,
                    function: (val) => {
                        if (parseInt(val) === NaN) {
                            return "---";
                        }
                        let str = "";
                        switch (parseInt(val)) {
                            case 0:
                                str = "待申报";
                                break;
                            case 1:
                                str = "已申报";
                                break;
                            case 2:
                                str = "已审核";
                                break;
                        }
                        return str;
                    },
                },
            ];
            return columns;
        },

        // 选择申报表格列
        selectColumns() {
            let columns = [
                {
                    prop: "proName",
                    title: "工程项目名称",
                    minWidth: 150,
                    width: 0,
                    headerAlign: "center",
                    align: "left",
                },
                {
                    prop: "proTypeName",
                    title: "项目类型",
                    minWidth: 0,
                    width: 120,
                    headerAlign: "center",
                    align: "left",
                },
                {
                    prop: "companyName",
                    title: "建设单位",
                    minWidth: 150,
                    width: 0,
                    headerAlign: "center",
                    align: "left",
                },
                {
                    prop: "personName",
                    title: "建设单位负责人",
                    minWidth: 200,
                    width: 0,
                    headerAlign: "center",
                    align: "left",
                },
            ];

            let current = this.khlx.find((x) => x.value === this.selectedType);
            if (current) {
                columns.push({
                    prop: current.value,
                    title: current.sname,
                    minWidth: 0,
                    width: 160,
                    headerAlign: "center",
                    align: "center",
                    needRender: true,
                    function: (val) => {
                        return "未考核";
                    },
                });
            }

            return columns;
        },

        // 个人信息
        ...mapState("user", {
            userInfo: (state) => state.userInfo,
        }),

        // 考核类型
        ...mapState("dict", {
            khlx: (state) => state.projectDict.khlx, // 考核类型数组,
        }),
    },
    watch: {
        // 监听选择的 考核类型
        selectedType(val) {
            let _item = this.khlx.find((x) => x.value === val);
            this.evaluateObj.markObjName = _item ? _item.sname : "";
        }
    }
};
</script>

<style scoped lang="less">
.select-header {
    line-height: 36px;
    margin-bottom: 15px;
    span {
        display: inline-block;
        margin-right: 20px;
        background-color: #f2f2f2;
        padding: 0 15px;
        cursor: pointer;

        &.active {
            background-color: #60adf9;
            color: #fff;
        }
    }
}
</style>
